const user = {
  state: {
    uid: null,
    name: null,
    // schId: null,
    // type: null,
    gender: null,
    avatar: null,
    points: 0,
  },
  mutations: {
    // 注意：原代码拼写错误 setUseInfo → setUserInfo（建议修正，避免后续调用出错）
    setUserInfo(state, user) {
      state.uid = user.uid;
      state.name = user.name;
      // state.schId = user.schId;
      // state.type = user.type;
      state.gender = user.gender;
      state.avatar = user.avatar;
    },
    clearUserInfo(state) {
      state.uid = null;
      state.name = null;
      // state.schId = user.schId;
      // state.type = user.type;
      state.gender = null;
      state.avatar = null;
      state.point = 0;
    },
    setPoints(state, point) {
      state.points = point;
    },
  },
};

export default user;
